import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    Avatar,
    ListItemText,
    Button,
    useMediaQuery,
    useTheme,
    Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { get, put } from '../../utility/fetch';
import notification from '../../utility/notification';

const sampleGroups = [
    { id: 1, name: 'Fitness & Wellness', description: 'Get fit, stay healthy', avatar: 'https://randomuser.me/api/portraits/men/11.jpg' },
    { id: 2, name: 'The Kids Corner', description: 'Fun activities for children', avatar: 'https://randomuser.me/api/portraits/women/12.jpg' },
    { id: 3, name: 'Cooking Club', description: 'Delicious recipes and more', avatar: 'https://randomuser.me/api/portraits/men/13.jpg' },
    { id: 4, name: 'Mental Health Circle', description: 'Support and talk', avatar: 'https://randomuser.me/api/portraits/women/14.jpg' },
];

const GroupJoinModal = ({ open, onClose }) => {

    const [groups, setGroups] = useState([]);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const handleJoin = async (group) => {
        console.log(`Joining group: ${group.id}`);
        console.log(group);

        let res = await put(`/communitygroup/${group?.id}/join-community-group`)
        if(res?.statusCode === 200){
            notification({
                type:"success",
                message:res?.data?.message
            })
            getGroups();
        }
        else{
            notification({
                type:"error",
                message:res?.data?.message || "Something went wrong joining group"
            })
        }
        console.log(res);

        // Add your API or state logic here
    };



    const getGroups = async () => {
        let res = await get("/communitygroup/list");
        if (res?.statusCode === 200) {
            setGroups(res?.data);
        }
        console.log(res);
    }

    useEffect(() => {
        getGroups()
    }, [])

    return (
        <Dialog open={open} onClose={onClose} fullScreen={fullScreen} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Join a Community Groups
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <List disablePadding>
                    {groups?.map((group) => (
                        <ListItem
                            key={group.id}
                            sx={{
                                borderBottom: `1px solid ${theme.palette.divider}`,
                                py: 1,
                            }}
                            secondaryAction={
                                !group?.communityGroupMembers?.some(
                                    m => 
                                        (m?.patient?.id === Number(sessionStorage?.getItem("userId"))) ||
                                        (m?.employee?.id === Number(sessionStorage?.getItem("userId")))
                                ) && (
                                    <Button
                                        variant="contained"
                                        size="small"
                                        sx={{
                                            textTransform: 'none',
                                            fontSize: 12,
                                            bgcolor: '#29BA2E',
                                            px: 2,
                                            py: 0.5,
                                            borderRadius: 3,
                                            '&:hover': { bgcolor: '#219a25' },
                                        }}
                                        onClick={() => handleJoin(group)}
                                    >
                                        Join
                                    </Button>
                                )
                            }
                        >
                            <ListItemAvatar>
                                <Avatar src={group.pictureUrl} alt={group.name} />
                            </ListItemAvatar>
                            <ListItemText
                                primary={group.name}
                                secondary={group.description.substring(0, 25) + '...'}
                                primaryTypographyProps={{ fontWeight: 600 }}
                                secondaryTypographyProps={{ fontSize: 12 }}
                            />
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
        </Dialog>
    );
};

export default GroupJoinModal;
